<template>
  <div>
    <div class="bolder">교과목: {{subject.name}}</div>
    <mdb-tbl class="ml-3 my-2" sm>
      <mdb-tbl-head>
        <tr class=" blue lighten-5">
          <th style="width:40%">단원</th>
          <th style="width:10%">훈련시간</th>
          <th style="width:40%">중단원</th>
          <th style="width:10%">훈련시간</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(l, i) in subject.lectures" :key="i">
          <td>{{l.name}}</td>
          <td>{{l.hours}}</td>
          <td><div  v-for="(u, i) in l.units" :key="i">{{u.name}}</div></td>
          <td><div  v-for="(u, i) in l.units" :key="i">{{u.hours}}</div></td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
  </div>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue';
export default {
  name: 'SubjectStructure',
  components: { mdbTbl, mdbTblHead, mdbTblBody },
  props: ['subject'],
  data: () => ({
  }),
  computed: {
  },
  watch: {
    async trainingId () {
      this.subject = await this.$getsubject(this.trainingId)
    }
  }
}
</script>
